import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

import { IconChevronRight as ChevronRight } from '../../core';

interface Props {
  className?: string;
  href: string;
  children: string;
}

const Link = ({ className = '', children, href }: Props) => (
  <RouterLink className={className} to={href}>
    {children}
    <ChevronRight />
  </RouterLink>
);

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.primaryText};
  text-decoration: none;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.sm};
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-weight: 500;
  gap: 2px;

  &:hover {
    color: ${({ theme }) => theme.primaryTextHover};
  }

  &:active {
    color: ${({ theme }) => theme.primaryActionActive};
  }
`;

export default StyledLink;
